import { Injectable } from '@angular/core';
import { API_ENDPOINTS } from '../constants/api-endpoints.constant';
import { ApiService } from './api.service';
import { environment } from 'src/environments/environment';
import * as RecordRTC from 'recordrtc';
import * as moment from 'moment';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { isNullOrUndefined } from 'util';
import { WebsocketService } from './websocket.service';
import { map } from 'rxjs/operators';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AudioNotPublishedComponent } from 'src/app/components/all-modals/audio-not-published/audio-not-published.component';
import { AudioDisableComponent } from 'src/app/components/all-modals/audio-disable/audio-disable.component';
import { HttpClient } from '@angular/common/http';

interface RecordedAudioOutput {
  blob: Blob;
  title: string;
}


@Injectable({
  providedIn: 'root'
})
export class ChatService {

  microPhoneerror:boolean=false;

  CHAT_URL = environment.chat_url;

  private stream;
  private recorder;
  private interval;
  private startTime;
  private _recorded = new Subject<RecordedAudioOutput>();
  private _recordingTime = new Subject<string>();
  private _recordingFailed = new Subject<string>();
  acceptRequest = new BehaviorSubject<any>('');
  notificationData = new BehaviorSubject<any>('');
  messages: Subject<any>;
  deleteMessages: Subject<any>;

  signedUrlObservable = new Subject<any>();

  constructor(private _apiService: ApiService,
    private modalService: NgbModal,
    private http: HttpClient,

    private wsService: WebsocketService
  ) {


    // this.messages = <Subject<any>>wsService
    //   .connect()
    //   .pipe(
    //     map((response: any): any => {
    //       return response;
    //     })
    //   );
  }

  watchSignedUrlObservable(): Observable<any> {
    return this.signedUrlObservable.asObservable();
  }

  watchNotificationData(): Observable<any> {
    return this.notificationData.asObservable();
  }

  watchAcceptRequest(): Observable<any> {
    return this.acceptRequest.asObservable();
  }

  connectToSocket(userObj) {
    this.messages = <Subject<any>>this.wsService
      .connect(userObj)
      .pipe(
        map((response: any): any => {
          return response;
        })
      );
      this.deleteMessages = <Subject<any>>this.wsService
      .connect(userObj)
      .pipe(
        map((response: any): any => {
          return response;
        })
      );
  }

  // connectToSocketfordeleteevent(userObj)
  // {
  //   this.deleteMessages = <Subject<any>>this.wsService
  //   .connect(userObj)
  //   .pipe(
  //     map((response: any): any => {
  //       return response;
  //     })
  //   );
  // }
  // Audio Recorder Service Methods
  getRecordedBlob(): Observable<RecordedAudioOutput> {
    return this._recorded.asObservable();
  }

  getRecordedTime(): Observable<string> {
    return this._recordingTime.asObservable();
  }

  recordingFailed(): Observable<string> {
    return this._recordingFailed.asObservable();
  }


  startRecording() {


       if (this.recorder) {
      // It means recording is already started or it is already recording something
      return;
    }

    this._recordingTime.next('00:00');
    navigator.mediaDevices.getUserMedia({ audio: true }).then(s => {
      this.stream = s;
      this.record();
    }).catch(error => {
      this._recordingFailed.next();
      this.microPhoneerror= true
      this.modalService.open(AudioDisableComponent, { centered: true });


    });

  }

  abortRecording() {
    this.stopMedia();
  }

  getChatNotification() {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}/connections/notification_list`;
    return this._apiService.get(url);
  }

  getUserDetailBySku(sku) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}/user_detail/`;
    return this._apiService.get(url, sku);
  }

  private record() {
    this.recorder = new RecordRTC.StereoAudioRecorder(this.stream, {
      type: 'audio',
      mimeType: 'audio/webm'
    });

    this.recorder.record();
    this.startTime = moment();
    this.interval = setInterval(
      () => {
        const currentTime = moment();
        const diffTime = moment.duration(currentTime.diff(this.startTime));
        const time = this.toString(diffTime.minutes()) + ':' + this.toString(diffTime.seconds());
        this._recordingTime.next(time);
      },
      1000
    );
  }

  private toString(value) {
    let val = value;
    if (!value) {
      val = '00';
    }
    if (value < 10) {
      val = '0' + value;
    }
    return val;
  }

  stopRecording(flag?) {
    if (this.recorder) {
      this.recorder.stop((blob) => {
        if (this.startTime) {
          const mp3Name = encodeURIComponent('audio_' + new Date().getTime() + '.mp3');
          this.stopMedia();
          if(flag){
            this._recorded.next({ blob: blob, title: mp3Name });
          }
        }
      }, () => {
        this.stopMedia();
        this._recordingFailed.next();
      });
    }
  }

  private stopMedia() {
    if (this.recorder) {
      this.recorder = null;
      clearInterval(this.interval);
      this.startTime = null;
      if (this.stream) {
        this.stream.getAudioTracks().forEach(track => track.stop());
        this.stream = null;
      }
    }
  }

  ///////// Socket Io ///////////
  sendMsg(msg) {
    this.messages.next(msg);
  }

  getUserList(page?) {
    let url;
    if(page){

       url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONNECTIONS}${API_ENDPOINTS.API.CHAT_LIST}?page=${page}`;
    } else {
       url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONNECTIONS}${API_ENDPOINTS.API.NOTIFICATION_CHAT_LIST}`;
    }
    return this._apiService.get(url);
  }

  getNotificationList() {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.NOTIFICATION_CHAT_LIST}`;
        return this._apiService.get(url);
  }

  getUsersListInBatch(offset: number){
    const limit = 10;
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONNECTIONS}${API_ENDPOINTS.API.CHAT_LIST}?offset=${offset}&limit=${limit}`;

    return this._apiService.get(url);

  }

  getSignleChat(param) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONNECTIONS}${API_ENDPOINTS.API.SINGLE_CHAT_CONNECTION}`;
    return this._apiService.get(url, param);
  }

  getChatSearch(searchTerm: string) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CHAT_USERS_SEARCH}?search_term=${searchTerm}`
    return this._apiService.get(url);
  }

  // Checks if a chat is already present
  findRecipient(recipient) {
    // const headers = new Headers({
    //   'Content-Type': 'application/json',
    //   'Authorization': this.authservice.authToken
    // });
    // const url = 'http://localhost:3000/chat/find/' + recipient;
    // //
    // //
    // return this.http.get(url, { headers: headers })
    //   .pipe(
    //     map((res => res.json()))
    //   );
    const url = `${environment.socketUrl}chat/find/${recipient}`;
    return this._apiService.get(url);
  }

  // Creates a new chat,with sender and receiver
  newChat(params) {
    // const headers = new Headers({
    //   'Content-Type': 'application/json',
    //   'Authorization': this.authservice.authToken
    // });
    // const url = '${environment.socketUrl}chat/new/' + recipient;
    // //
    // //
    // return this.http.get(url, { headers: headers })
    //   .pipe(
    //     map((res => res.json()))
    //   );
    const url = `${environment.socketUrl}direct/create`;
    return this._apiService.post(url, params);
  }


  sendReply(params, id) {
    // const headers = new Headers({
    //   'Content-Type': 'application/json',
    //   'Authorization': this.authservice.authToken
    // });
    // const url = '${environment.socketUrl}chat/' + message.conversation_id;
    // return this.http.post(url, message, { headers: headers })
    //   .pipe(
    //     map((res => res.json()))
    //   );
    const url = `${environment.socketUrl}chat/${id}`;
    return this._apiService.post(url, params);
  }

  sendAttachment(params) {
    const url = `${environment.socketUrl}chat/media/upload`;
    return this._apiService.mulitipartForm(url, params);
  }

  sendAttachmentMultiple(params) {
    const url = `${environment.socketUrl}chat/media/multiple/upload`;
    return this._apiService.mulitipartForm(url, params);
  }

  getMessages(conversationId, page, loggedInUserSKU?) {
    let url = '';
    if (loggedInUserSKU) {
      url = `${environment.socketUrl}chat/list/${conversationId}/${loggedInUserSKU}/${page}`;
    } else {
      url = `${environment.socketUrl}chat/list/${conversationId}/${page}`;
    }
    return this._apiService.get(url);
  }

  getLastMessages(params) {
    const url = `${environment.socketUrl}chat/all/latest`;
    return this._apiService.post(url, params);
  }

  getPresignedUrl(params) {
    const url = `${environment.socketUrl}chat/media/presigned_url`;
    return this._apiService.post(url, params);
  }

  getLastSeen(id) {
    const url = `${environment.socketUrl}users/status/${id}`;
    return this._apiService.get(url);
  }

  getUserStatus(params) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.CONNECTIONS}${API_ENDPOINTS.API.GET_USER_STATUS}`;
    return this._apiService.get(url, params);
  }

  createGroup(data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.GROUPS}`;
    return this._apiService.post(url, data);
  }

  editGroupDetail(id, data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.GROUPS}/${id}`;
    return this._apiService.put(url, data);
  }

  editGroup(data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.GROUPS}${API_ENDPOINTS.API.ADD_USER_INTO_GROUP}`;
    return this._apiService.post(url, data);
  }

  removeUserFromGroup(data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.GROUPS}${API_ENDPOINTS.API.REMOVE_USER_FROM_GROUP}`;
    return this._apiService.post(url, data);
  }

  deleteGroup(id) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.GROUPS}` + '/' + id;
    return this._apiService.delete(url);
  }

  leaveGroup(data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.GROUPS}${API_ENDPOINTS.API.LEAVE_GROUP}`;
    return this._apiService.post(url, data);
  }

  deleteMessage(data) {
    const url = `${API_ENDPOINTS.BASE_URL}${API_ENDPOINTS.VERSION}${API_ENDPOINTS.API.GROUPS}${API_ENDPOINTS.API.DELET_MESSAGE}`;
    return this._apiService.post(url, data);
  }


  filterDeletedMessages(messagelist:Array<any>, userId){

    return messagelist.filter(message => {
      const deletableMessageInfo =  message.delete_array.find(deletableMsgInfo => deletableMsgInfo.user_id === userId);
      if(deletableMessageInfo != null ){

        return deletableMessageInfo.is_deleted === 0;
      }
      else
      {
         return true
      }
    });
  }

}
